import { Controller } from 'react-hook-form';

import Input from './Input';
import { type ControlledInputProps } from './types';

export const ControlledInput = (props: ControlledInputProps) => {
    const { name, control, defaultValue, ref } = props;
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field, fieldState }) => (
                <Input {...field} {...props} ref={ref} errorMessage={fieldState.error?.message} />
            )}
        />
    );
};

export default ControlledInput;
